export default {
  SET_LOADING(state, payload) {
    state.loading = payload;
  },
  SET_ELEMENT(state, payload) {
    state.elements[payload.id] = payload;
  },
  SET_RULES(state, { id, rules }) {
    state.rules[id] = rules;
  },

};
